"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import UiGrid, {
  GridController
} from "@/components/grid/UiGrid.vue";
import DatasItems from "@/views/costItems/components/DatasItems.vue";
import { APIDataSource } from "@/components/grid/data-source";
const _gridController = new GridController(
  // new APIDataSource("api://base.auth/api/v7/groups/shop_list_new")
  // new APIDataSource("api://base.auth.kv.shops/v1/shops")
  new APIDataSource("api://base.auth.pro/v1/shops")
);
let AllotmentShop = class extends Vue {
  constructor() {
    super(...arguments);
    this.controller = _gridController;
    this.empty = " ";
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(`"${this.user_id}"`);
        let userIds = arr.join(",");
        this.controller.pagePosition = "dialog";
        this.controller.query.params = {
          // search: {
          //   user_ids: arr,
          // },
          search: `userIds=in=(${userIds})`,
          type: `SHOW`
        };
        if (this.user_id !== "" && this.user_id !== null) {
          yield this.controller.search();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  start() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(`"${this.user_id}"`);
        let userIds = arr.join(",");
        this.controller.pagePosition = "dialog";
        this.controller.query.params = {
          // search: {
          //   user_ids: arr,
          // },
          search: `userIds=in=(${userIds})`,
          type: `SHOW`
        };
        if (this.user_id !== "" && this.user_id !== null) {
          yield this.controller.search();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  search(id) {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(`"${id}"`);
        let userIds = arr.join(",");
        this.controller.pagePosition = "dialog";
        this.controller.query.params = {
          // search: {
          //   user_ids: arr,
          // },
          search: `userIds=in=(${userIds})`,
          type: `SHOW`
        };
        if (this.user_id !== "" && this.user_id !== null) {
          yield this.controller.search();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("userId")
], AllotmentShop.prototype, "user_id", 2);
AllotmentShop = __decorateClass([
  Component({
    components: {
      UiGrid,
      DatasItems
    }
  })
], AllotmentShop);
export {
  AllotmentShop as default
};
